import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import AdminOverview from './AdminOverview';
import AdminUsers from './AdminUsers';
import AdminDocuments from './AdminDocuments';
import AdminProjects from './AdminProjects';
import AdminContactMessages from './AdminContactMessages';
import AdminPlanLimits from './AdminPlanLimits';
import AdminEmail from './AdminEmail';
import AdminShortLinks from './AdminShortLinks';
import AdminInternalAds from './AdminInternalAds';
import AdminSupportTickets from './AdminSupportTickets';
import AdminLandingPages from './AdminLandingPages';
import PlayStoreEmails from '../PlayStoreEmails';

const AdminRouter = ({ user, onLogout }) => {
  return (
    <AdminLayout user={user} onLogout={onLogout}>
      <Routes>
        <Route path="/" element={<AdminOverview />} />
        <Route path="/users" element={<AdminUsers />} />
        <Route path="/documents" element={<AdminDocuments />} />
        <Route path="/projects" element={<AdminProjects />} />
        <Route path="/shortlinks" element={<AdminShortLinks />} />
        <Route path="/internal-ads" element={<AdminInternalAds />} />
        <Route path="/support-tickets" element={<AdminSupportTickets />} />
        <Route path="/landing-pages" element={<AdminLandingPages />} />
        <Route path="/contact-messages" element={<AdminContactMessages />} />
        <Route path="/playstore-emails" element={<PlayStoreEmails />} />
        <Route path="/plan-limits" element={<AdminPlanLimits />} />
        <Route path="/email" element={<AdminEmail />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRouter;
